import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from 'components/v2/forms/TextField';

export default function InputWithTrailingIcon({
  className,
  children,
  dataTestId,
  ...props
}) {
  return (
    (<div
      data-testid={dataTestId}
      className={classnames('relative rounded-md shadow-sm', className)}>
      <TextField dataTestId="TextField-458256d7" {...props} />
      <div
        data-testid="div-00393e45"
        className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        {children}
      </div>
    </div>)
  );
}

InputWithTrailingIcon.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  children: PropTypes.node.isRequired,
};
